/**
 * Plain text as it must appear inside `data-operator-description`. The attribute holds HTML that
 * the page scraper splices into Operator's page read verbatim, so text has to be escaped or a
 * stray `<` or `&` reads as markup. Elements built with `document.createElement` and
 * `textContent` get this for free from `outerHTML`; this is for the bare-text case.
 */
export const escapeOperatorDescriptionText = (text: string): string => {
  const element = document.createElement("span");
  element.textContent = text;
  return element.innerHTML;
};
